export default __webpack_public_path__ + "media/images/orange-grass-bg-633e0e7e9e283da193124381e7700069.svg";